import { FlowType } from '@domain/types';
import { NotificationActions } from '@store/notificationWindow/notificationWindow.action';

import { NOTIFICATION_LOADED_MESSAGE, NOTIFICATION_SHOW_MAIN } from './constants';

const FLOW_TYPES: readonly FlowType[] = ['integration', 'sending'];

/**
 * Every channel the client can legitimately push through the `bridge:util:sendTo` relay,
 * derived from the constants that actually build them rather than hand-typed.
 *
 * The main process refuses anything outside SENDTO_ALLOWED_CHANNELS in
 * packages/electron/src/main/ipc/handlers/util.handlers.ts. `relayChannels.spec.ts` freezes
 * this set against a literal list, so adding a channel here fails that test until the main
 * process allowlist is updated too — the two cannot drift apart silently.
 */
export const RELAY_CHANNELS: ReadonlySet<string> = new Set<string>([
  NOTIFICATION_LOADED_MESSAGE,
  ...FLOW_TYPES.map((flowType) => `${NOTIFICATION_SHOW_MAIN}/${flowType}`),
  ...Object.values(NotificationActions).map((action) => action.type),
]);
